function getCart(callback) {
    $.ajax({
      type: 'GET', 
      url: '/cart.js', 
      dataType: 'json', 
      success: function(data){
      	callback(data);
      },
      error: function(){}
    });
  }

$(document).ready(function(){ 

  // fixed nav JS
   var initScroll = $(window).scrollTop();
   if (initScroll >= 150) {
		   $("body").addClass("fixed-nav");
   }
   $(window).scroll(function() {    
	   var scroll = $(window).scrollTop();

	   if (scroll >= 150) {
		   $("body").addClass("fixed-nav");
	   } else if(scroll <= 100) {
		   $("body").removeClass("fixed-nav");
	   }
   });

  // pre-order links
  $('a[href="https://recordtowntx.tuneportals.com/"]').attr('target', '_blank');
  
//   about us gallery
  var initialSlide = 0;
  var slickInit = 0;
   $('.gallery-item').click(function() {
     initialSlide = $(this).data('slide') - 1;
     var content = $(this).children('.content-page').html();
     $('#popup-image-gallery .main-image').html(content).removeClass('slick-initialized').removeClass('slick-slider');
     $('#popup-image-gallery .thumbnail-image').html(content).removeClass('slick-initialized').removeClass('slick-slider');
     $('#popup-image-gallery').modal('show');
   });
  $('#popup-image-gallery .close-btn').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
     $('#popup-image-gallery').modal('hide');
   });
  // Slick controls
  $('#popup-image-gallery').on('shown.bs.modal', function() {
      $('.main-image').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: initialSlide,
        arrows: true,
        fade: true,
        asNavFor: '.popup-slider-nav .thumbnail-image',
        prevArrow: '<div class="slick-prev">Prev</div>',
        nextArrow: '<div class="slick-next">Next</div>'
        // adaptiveHeight: true,
      });
      $('.popup-slider-nav .thumbnail-image').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.main-image',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        variableWidth: true,
        centerMode: true,
        infinite: true,
      });
    
  });

  // Slick slider sync situation
  var slides = $(".main-image .slick-track > .slick-slide").length;
  $('.main-image').on('afterChange', function(event, slick, currentSlide, nextSlide) {
    var inFocus = $('.main-image .slick-current').attr('data-slick-index');
    $('.thumbnail-image .slick-current').removeClass('slick-current');
    $('.thumbnail-image .slick-slide[data-slick-index="' + inFocus + '"]').trigger('click');
  });  
//  end about us gallery
 function addItem(form,handle) {
    $(handle).parent().find('.quick-view-add-to-cart').attr("value","Processing..");
    $(handle).parent().find('.quick-view-add-to-cart').attr("pointer-events","none");
     $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $(form).serialize(),
        success: function(data){
          getCart(function(data){
            var cart = $('.right_nav .fa-shopping-cart');
                  var imgtodrag = $(handle).parent().parent().parent().find("img").eq(0);
                  if (imgtodrag) {
                      var imgclone = imgtodrag.clone()
                          .offset({
                          top: imgtodrag.offset().top,
                          left: imgtodrag.offset().left
                      })
                          .css({
                          'opacity': '0.8',
                            'z-index':'9999999999999999',
                              'position': 'absolute',
                              'height': '150px',
                              'width': '150px',
                              'z-index': '100'
                      })
                          .appendTo($('body'))
                          .animate({
                          'top': cart.offset().top + 10,
                              'left': cart.offset().left + 10,
                              'width': 75,
                              'height': 75
                      }, 1000, 'easeInOutExpo');

          //             setTimeout(function () {
          //                 cart.effect("shake", {
          //                     times: 2
          //                 }, 200);
          //             }, 1500);

                      imgclone.animate({
                          'width': 0,
                              'height': 0
                      }, function () {
                          $(this).detach()
                      });
                  }
                $(handle).parent().find('.quick-view-add-to-cart-load').css('display','block');
            	$(handle).parent().find('.quick-view-add-to-cart').attr("value",'Added to cart..');
              setTimeout(function(){
                $('.cart_item_count').html(data.item_count).removeClass("hide");
            	 $(handle).parent().find('.quick-view-add-to-cart').attr("value","Add to cart");
              	 $(handle).parent().find('.quick-view-add-to-cart-load').css('display','none');
                 $(handle).parent().find('.quick-view-add-to-cart').attr("pointer-events","all");
              },1000);
          });
        },
        error: function(e){console.log('logo', e);}
     });
  }
  
  
/* HOMEPAGE */
 /*Quick View add to cart*/
//   setTimeout(function(){
//   	$('.raqs-button-wrapper').append('<button class="btn btn-primary quick-view-add-to-cart">Add to cart</button>');
//   },6000);
  
  $('body').on('click','.quick-view-add-to-cart',function(event){
	   	event.stopPropagation();
    	event.preventDefault();
    	addItem($(this).closest('form'),this);
    	console.log($(this).closest('form'));
  });
  
  /* special order slider*/
  
  $('.special_order_block_wrapper').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow:'<button type="button" class="slick-prev"></button>',
  	nextArrow:'<button type="button" class="slick-next">',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        rows:2,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
  });
  //  $(this).siblings('.service-content-wrapper').toggleClass('active');

  //   Faq Accordian
  $(document).ready(function() {
    $(".faq_acc > a").on("click", function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
        .siblings(".faq_content")
        .slideUp(200);
        $(this).find("i")
        .removeClass("fa-angle-up")
        .addClass("fa-angle-down");
      } else {
        $(this)
        .find("i")
        .removeClass("fa-angle-down")
        .addClass("fa-angle-up");
        //$(".faq_acc > a").removeClass("active");
        $(this).addClass("active");
        $(this)
        .siblings(".faq_content")
        .slideDown(200);
      }
    });
    $(".faq_content > h3").on("click", function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
        .next(".check_box")
        .slideUp(200);
        $(this).find("i")
        .removeClass("fa-angle-up")
        .addClass("fa-angle-down");
      } else {
        $(this)
        .find("i")
        .removeClass("fa-angle-down")
        .addClass("fa-angle-up");
        //$(".faq_acc > a").removeClass("active");
        $(this).addClass("active");
        $(this)
        .next(".check_box")
        .slideDown(200);
      }
    });
  });  
  
  $(document).ready(function() {
//     $(".staff_new_single .sidebar_list .faq_acc > a").on("click", function() {
//       if(window.innerWidth >= 769){
//       if ($(this).hasClass("active")) {
//         $(this).removeClass("active");
//         $(this)
//         .siblings(".faq_content")
//         .slideUp(200);
//         $(".faq_acc > a i")
//         .removeClass("fa-angle-up")
//         .addClass("fa-angle-down");
//       } else {
//         $(".faq_acc > a i")
//         .removeClass("fa-angle-up")
//         .addClass("fa-angle-down");
//         $(this)
//         .find("i")
//         .removeClass("fa-angle-down")
//         .addClass("fa-angle-up");
//         $(".faq_acc > a").removeClass("active");
//         $(this).addClass("active");
//         $(".faq_content").slideUp(200);
//         $(this)
//         .siblings(".faq_content")
//         .slideDown(200);
//       }
//       }
//     });
  }); 

  //   Loader
//   jQuery(window).bind("load", function () {
//     if (document.readyState === "complete") {
//       setTimeout(function () {
//         // loader
//         jQuery(".loader").fadeOut(500);

//       }, 500);
//     }

//   });

});

$(window).scroll(function() {
  if(window.innerWidth >= 223){
    if ($(this).scrollTop() > 50) {
        $('#header_custom').addClass('fixed-header');
    } else {
        $('#header_custom').removeClass('fixed-header');
    }
  }
});

// $(window).scroll(function() {
//   if(window.innerWidth <= 993){
//     if ($(this).scrollTop() > 122) {
//         $('.header-bottom').addClass('fixed-header');
//     } else {
//         $('.header-bottom').removeClass('fixed-header');
//     }
//   }
// });

// $(window).scroll(function() {
//   if(window.innerWidth <= 993){
//     if ($(this).scrollTop() > 150) {
//         $('.header-bottom').addClass('fixed-header');
//     } else {
//         $('.header-bottom').removeClass('fixed-header');
//     }
//   }
// });


$(document).ready(function () {
  
  // Variable declaration...
  var left, width, newLeft;
  
  // Add the "top-menu" class to the top level ul...
  $('.mobile-navmenu').children('ul').addClass('top-menu');
  
  // Add buttons to items that have submenus...
  $('.has_child_menu').append('<button class="arrow"><i class="fa fa-chevron-right"></i></button>');
  
  // Mobile menu toggle functionality
    $('.menu-toggle').on('click', function () {
        
        // Detect whether the mobile menu is being displayed...
        display = $('.mobile-navmenu').css("display");
        
        if (display === 'none') {
            
            // Display the menu...
            $('.mobile-navmenu').css("display", "block");
            
        } else {
            
            // Hide the mobile menu...
            $('.mobile-navmenu').css("display", "none");
            
            // and reset the mobile menu...
            $('.current-menu').removeClass('current-menu');
            $('.top-menu').css("left", "0");
            $('.back-button').css("display", "none");
        }
    });

  // Functionality to reveal the submenus...
  $('.arrow').on('click', function () {
    // The .current-menu will no longer be current, so remove that class...
    $('.current-menu').removeClass('current-menu');

    // Turn on the display property of the child menu
    $(this).siblings('ul').css("display", "block").addClass('current-menu');

    left = parseFloat($('.top-menu').css("left"));
    width = Math.round($('.mobile').width());
    newLeft = left - width;

    // Slide the new menu leftwards (into the .mobile viewport)...
    $('.top-menu').css("left", newLeft);
    
    // Also display the "back button" (if it is hidden)...
    if ($('.back-button').css("display") === "none") {
        $('.back-button').css("display", "flex");
    }

  });

  // Functionality to return to parent menus...
  $('.back-button').on('click', function () {
    
    // Hide the back button (if the current menu is the top menu)...
    if ($('.current-menu').parent().parent().hasClass('top-menu')) {
        $('.back-button').css("display", "none");
    }

    left = parseFloat($('.top-menu').css("left"));
    width = Math.round($('.mobile').width());
    newLeft = left + width;

    // Slide the new menu leftwards (into the .mobile viewport)...
    $('.top-menu').css("left", newLeft);

    // Allow 0.25 seconds for the css transition to finish...
    window.setTimeout(function () {

      // Hide the out-going .current-menu...
      $('.current-menu').css("display", "none");

      // Add the .current-menu to the new current menu...
      $('.current-menu').parent().parent().addClass('current-menu');

      // Remove the .current-menu class from the out-going submenu...
      $('.current-menu .current-menu').removeClass('current-menu');

    }, 250);

  });
  
  
   //   submenu 
  
  $('.mobile-sub-item>a').on('click', function (){
  	$(this).parent().toggleClass('sub-item-open');
  })
  
  $('.mobile-sub-item-2>a.sub-item-link2').on('click', function (e){
    e.preventDefault();
    e.stopPropagation();
  	$(this).parent().toggleClass('sub-item-open');
  })

});

$(document).ready(function(){
    $(".mobile-controls button").click(function(){
        $('body').toggleClass("fixed_body");
    });
});

$(document).ready(function(){
    $(".mobile-controls button").click(function(){
        $('.menu-toggle').toggleClass("close_nav");
    });
  $(".variants_data li").click(function(){
    $(this).parent().find(".var_active").removeClass("var_active");
    $(this).addClass("var_active");
    var attr = $(this).find("span").attr("data-text");
    var attr_price=$(this).find("span").attr("data-price");
    $(".product__price span[data-regular-price]").text(attr_price);
    $(this).parents(".product_desc").find(".product-form__variants").val(attr).trigger("change");
  });
 $('body').on('click','.ico_search',function(event){
	 $("#SearchDrawer").addClass("showme");
  });
  $('body').on('click','.mob_only.cross_icon',function(event){
	 $("#SearchDrawer").removeClass("showme");
  });
  $('body').on('click','.filter',function(event){
	 $(".sidebar_list .left_side_bar").addClass("show_filter");
  });
    $('body').on('click','.filterscoss',function(event){
	 $(".sidebar_list .left_side_bar").removeClass("show_filter");
  });
  $(".reset_button").click(function(){
$(this).parents("form").find("input,textarea").val("");
$(this).parents("form").find("select").val("Mailorder Support").trigger("change");
});
    $('body').on('click','.btnqty.icon-plus',function () {
    	$(this).prev().val(+$(this).prev().val() + 1).trigger("change");
  });
  $('body').on('click','.btnqty.icon-minus',function () {
          if ($(this).next().val() > 0) {
          if ($(this).next().val() > 0) $(this).next().val(+$(this).next().val() - 1).trigger("change");
          }
  });
    $('.btnqty.icon-plus_prod').click(function () {
    	$(this).prev().val(+$(this).prev().val() + 1);
  });
  $('.btnqty.icon-minus_prod').click(function () {
          if ($(this).next().val() > 1) {
          if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
          }
  });
});

function openNav() {
  document.getElementById("mySidenav").style.width = "100%";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}
